import type { QueryHookOptions, QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getAlert } from '#/graphql/queries';
import type { GetAlertQuery } from '#/graphql/types';
import { merge } from 'lodash';

export const GET_ALERT = gql(getAlert);

const useAlertQuery = (id?: string, options?: QueryHookOptions) => {
  const query: QueryResult<GetAlertQuery> = useQuery(
    GET_ALERT,
    merge({ variables: { id }, fetchPolicy: 'cache-and-network' }, options || {}),
  );

  return query;
};

export default useAlertQuery;
